import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Progress } from '../ui';
import { StepItem } from './StepItem';

/**
 * One chapter of a path (spec §10.4). A chapter carries the mix of step kinds
 * its source actually provides — content to look at, questions to answer,
 * missions to run, practical tasks to do — and reports how many of its steps
 * are finished, not how much time was spent in it.
 */
export function ChapterSection({ chapter, onToggle }) {
  const { t } = useTranslation();
  const headingId = useId();

  const total = chapter.steps.length;
  const done = chapter.steps.filter((step) => step.completed).length;
  const title = chapter.titleKey ? t(chapter.titleKey) : chapter.title;

  return (
    <section className="etch-path__chapter" aria-labelledby={headingId}>
      <div className="etch-path__chapter-head">
        <div>
          <span className="etch-eyebrow">{t('onboarding.chapterIndex', { n: chapter.index })}</span>
          <h3 className="etch-path__chapter-title" id={headingId}>
            {title}
          </h3>
          {chapter.description && <p className="etch-path__chapter-description">{chapter.description}</p>}
        </div>
        {total > 0 && (
          <Progress
            className="etch-path__chapter-progress"
            value={done}
            max={total}
            showValue={false}
            ariaLabel={t('onboarding.progressOf', { completed: done, total })}
          />
        )}
      </div>

      {total === 0 ? (
        <p className="etch-path__chapter-empty">{t('onboarding.chapterEmpty')}</p>
      ) : (
        <ul className="etch-path__steps">
          {chapter.steps.map((step) => (
            <StepItem key={step.id} step={step} onToggle={onToggle} />
          ))}
        </ul>
      )}
    </section>
  );
}

export default ChapterSection;
